import {upperCase} from "lodash/string";

export function abTestUiTool() {
    window.addEventListener('DOMContentLoaded', () => {
        const featureFlagKey = 'ab_testing'
        if (CBS.Registry.Features[featureFlagKey] === true || CBS.Registry.Features[featureFlagKey.toUpperCase()] === true) {
            (async () => {
                const AbExperimentsModal = (await import('abTests/lib/AbExperimentsModal')).default;
                AbExperimentsModal();
            })();
        }
    });
}
